define('modules/accounts/users/detail/listLoginHistory',['require','exports','module','app','env','base/model'],function(require, exports, module) {
    "use strict";

    var app = require("app");
    var Config = require("env");

    var BaseModel = require("base/model");

    var Model = BaseModel.extend({
        urlRoot: function () {
          return Config.backendUrl + '/accounts/login-history';
        },
        initialize: function() {          
          this.initRequestEvents();
        },
        renderUserAgent: function (userAgent) {
            if (userAgent == null)
                return "--";
            if (/Windows/i.test(userAgent)) {
                return "Windows";
            }
            if (/Linux/i.test(userAgent)) {
                return "Linux";
            }
            if (/Mac/i.test(userAgent)) {
                return "Mac";
            }
            if (/iPhone/i.test(userAgent)) {
                return "iPhone";
            }
            if (/iPad/i.test(userAgent)) {
                return "iPad";
            }
            if (/Android/i.test(userAgent)) {
                if (/Tablet/i.test(userAgent)) {
                    return "Android Tablet";
                }
                return "Android";
            }
            return "--";
        }
    });

    module.exports = Model;
});

